import axios from "src/utils/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { errorAlert } from "src/utils/alerts";

export const getSubAdminList = createAsyncThunk(
  "admin/subAdmin-list",
  // Callback Function
  async ({ url, data, callback }, thunkAPI) => {
    try {
      const response = await axios.post(url, data);
      callback(response.data);
      return response.data;
    } catch (error) {
      const message =
        error.response && error.response.data
          ? error.response.data.message
          : "Something went wrong";
      errorAlert(message);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
